import React, { useEffect, useState } from 'react';
import Layout from '../Layout/Layout';
import './abroad.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Tinymce from '../../Tinymce/Tinymce';
import { Upload, XCircleIcon } from 'lucide-react';
import request from '../../../api/api';
import toast from 'react-hot-toast';

function AddAbroad() {
   const location = useLocation();
const isEdit = Boolean(location?.state?.abroad_id);

  const navigate = useNavigate();

  

  // SINGLE STATE FOR EVERYTHING
  const [form, setForm] = useState({
    country_name: "",
    country_img:"",
    order:'',
    country_note: {
      world_rank: "",
      graduate_visa: "",
      annual_fee: "",
      scholarship: "",
      international_std: "",
    },

    header: {
      main_head: "",
      head_img: null,
      content: "",
      content_side: ""
    },

    second_header: {
      main_head: "",
      sec_img: null,
      content: "",
      content_side: ""
    },

    admissions_requirements: {
      heading: "Admission Content",
      content: ""
    },

    intake: {
      heading: "Intake Content",
      content: ""
    },

    cost: {
      heading: "Cost Information",
      content: ""
    },

    visa_requirements: {
      heading: "Visa Requirements",
      content: ""
    },

    scholarship: {
      heading: "Scholarship Information",
      content: ""
    },

    work_visa: {
      heading: "Work Visa Information",
      content: ""
    },

    createdByModel: "admin"
  });

   useEffect(() => {
  if (!isEdit) return;

  request({
    url: `/abroad/admin/abroad/detail`,
    method: "POST",
    data:{
      abroad_id:location?.state?.abroad_id
    }
  })
    .then(res => {
      const data = res.response;

      // Remove images because backend gives URLs, not File objects
      setForm({
        ...data,
        header: {
          ...data.header,
          head_img: null
        },
        second_header: {
          ...data.second_header,
          sec_img: null
        },
        country_img: null
      });
    })
    .catch(err => console.log(err));
}, [isEdit, location?.state?.abroad_id]);

  // ----------------------------
  // COMMON HANDLERS
  // ----------------------------

  // For normal input changes (text, number, etc.)
  const handleChange = (section, key, value) => {
    setForm(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value
      }
    }));
  };

  // For main level fields (like country name)
  const handleMain = (key, value) => {
    setForm(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // For file uploads
  const handleFile = (section, key, file) => {
    setForm(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: file
      }
    }));
  };

  // ----------------------------------------
  // SUBMIT FUNCTION
  // ----------------------------------------
  const handleSubmit = async () => {
    const formData = new FormData();

    const payload = { ...form };

    // attach structured data
    formData.append("data", JSON.stringify(payload));

    // attach images
    if (form.header.head_img) {
      formData.append("head_img", form.header.head_img);
    }
    if (form.second_header.sec_img) {
      formData.append("sec_img", form.second_header.sec_img);
    }
    if (form.country_img) {
      formData.append("country_img", form.country_img);
    }

    console.log("FINAL PAYLOAD:", payload);
    console.log("FORMDATA:", formData);

    request({
      url: isEdit? `/abroad/admin/update/abroad/${location?.state?.abroad_id}`:'/abroad/admin/create/abroad',
      method:"POST",
      data:formData
    }).then((res)=>{
      toast.success(res.message)
      navigate("/abroad")
      setForm({
    country_name: "",

    country_note: {
      world_rank: "",
      graduate_visa: "",
      annual_fee: "",
      scholarship: "",
      international_std: "",
    },

    header: {
      main_head: "",
      head_img: null,
      content: "",
      content_side: ""
    },

    second_header: {
      main_head: "",
      sec_img: null,
      content: "",
      content_side: ""
    },

    admissions_requirements: {
      heading: "Admission Content",
      content: ""
    },

    intake: {
      heading: "Intake Content",
      content: ""
    },

    cost: {
      heading: "Cost Information",
      content: ""
    },

    visa_requirements: {
      heading: "Visa Requirements",
      content: ""
    },

    scholarship: {
      heading: "Scholarship Information",
      content: ""
    },

    work_visa: {
      heading: "Work Visa Information",
      content: ""
    },

    createdByModel: "admin"
  })
      
    }).catch((err)=>{
      console.log(err)
    })

    
  };

  return (
    <Layout>
      <div className="add-abroad-form-container">
        <h2>{location?.state?.abroad_id?"Edit" :"Create"} Study Abroad Page</h2>

        {/* MAIN INFO */}
        <div className="abrd-main">Main information</div>
        <div className="row">

          <div className="col-12 my-2">
            <label className="lbl-name">Country Image</label>
          <label htmlFor="countryUpload" className="upload-label country">
            <Upload /> upload Country image
          </label>
          <input 
            type="file"
            hidden
            id="countryUpload"
            onChange={e => handleMain("country_img", e.target.files[0])}
          />
          <div>
            {
              form?.country_img && <div className='pre_img'>
                <XCircleIcon className='x_close' onClick={()=>setForm({
                  ...form,
                  country_img:""
                })}/>
                <img width={150} height={150} style={{marginTop:"20px"}} src={URL.createObjectURL(form?.country_img)}/>
              </div>
            }
          </div>
          </div>
          <div className="col-12 my-2">
            <label className="lbl-name">Order Number</label>
            <div>
              <input 
              type="number"
              value={form?.order}
              onChange={e => handleMain("order", e.target.value)}
            />
            </div>
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">Country Name</label>
            <div>
              <input 
              type="text"
              value={form?.country_name}
              onChange={e => handleMain("country_name", e.target.value)}
            />
            </div>
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">World Ranking</label>
            <div>
               <input 
              type="text"
               value={form?.country_note?.world_rank}
              onChange={e => handleChange("country_note", "world_rank", e.target.value)}
            />
            </div>
           
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">Graduate Visa PSW</label>
            <div>
               <input 
              type="text"
              value={form?.country_note?.graduate_visa}
              onChange={e => handleChange("country_note", "graduate_visa", e.target.value)}
            />
            </div>
           
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">Annual fee</label>
            <div>
              <input 
              type="text"
              value={form?.country_note?.annual_fee}
              onChange={e => handleChange("country_note", "annual_fee", e.target.value)}
            />
            </div>
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">Scholarship</label>
            <div>
              <input 
              type="text"
              value={form?.country_note?.scholarship}
              onChange={e => handleChange("country_note", "scholarship", e.target.value)}
            />
            </div>
          </div>

          <div className="col-6 my-2">
            <label className="lbl-name">International Students</label>
            <div>
              <input 
              type="text"
              value={form?.country_note?.international_std}
              onChange={e => handleChange("country_note", "international_std", e.target.value)}
            />
            </div>
          </div>

        </div>


        {/* HEADER SECTION */}
        <div className="abrd-main">Header Section</div>

        <div className="col-12 my-2">
          <label className="lbl-name">Header Name</label>
          <Tinymce 
            height={150}
            initialValue={form?.header?.main_head}
            content={form?.header?.main_head}
            handleEditorChange={v => handleChange("header", "main_head", v)}
          />
        </div>

        <div className="col-6">
          <label className="lbl-name">Header Image</label>
          <label htmlFor="headerUpload" className="upload-label">
            <Upload /> Choose Image
          </label>
          <input 
            type="file"
            hidden
            id="headerUpload"
            onChange={e => handleFile("header", "head_img", e.target.files[0])}
          />
          <div>
            {
              form?.header?.head_img && <div className='pre_img'>
                <XCircleIcon className='x_close' onClick={()=>setForm({
                  ...form,
                  header:{
                    ...form.header,
                    head_img:""
                  }
                })}/>
                <img width={150} height={150} style={{marginTop:"20px"}} src={URL.createObjectURL(form?.header?.head_img)}/>
              </div>
            }
          </div>
        </div>

        <div className="col-12 my-2">
          <label className="lbl-name">Header Content</label>
          <Tinymce 
            height={350} 
            initialValue={form?.header?.content}
            content={form?.header?.content}
            handleEditorChange={v => handleChange("header", "content", v)} 
          />
        </div>


        {/* SECOND HEADER SECTION */}
        <div className="abrd-main">Second Section</div>

        <div className="col-12 my-2">
          <label className="lbl-name">Second Header Name</label>
          <Tinymce 
            height={150}
            initialValue={form?.second_header?.main_head}
            content={form?.second_header?.main_head}
            handleEditorChange={v => handleChange("second_header", "main_head", v)}
          />
        </div>

        <div className="col-6">
          <label className="lbl-name">Second Header Image</label>
          <label htmlFor="secondUpload" className="upload-label">
            <Upload /> Choose Image
          </label>
          <input 
            type="file"
            hidden
            id="secondUpload"
            onChange={e => handleFile("second_header", "sec_img", e.target.files[0])}
          />
          <div>
            {
              form?.second_header?.sec_img && <div className='pre_img'>
                <XCircleIcon className='x_close' onClick={()=>setForm({
                  ...form,
                  second_header:{
                    ...form.second_header,
                    sec_img:""
                  }
                })}/>
                <img width={150} height={150} style={{marginTop:"20px"}} src={URL.createObjectURL(form?.second_header?.sec_img)}/>
              </div>
            }
          </div>
        </div>

        <div className="col-12 my-2">
          <label className="lbl-name">Second Header Content</label>
          <Tinymce 
            height={350}
            initialValue={form?.second_header?.content}
            content={form?.second_header?.content}
            handleEditorChange={v => handleChange("second_header", "content", v)}
          />
        </div>


        {/* ADDITIONAL CONTENTS */}
        {[
          ["admissions_requirements", "Admission Content"],
          ["intake", "Intake Content"],
          ["cost", "Cost Information"],
          ["visa_requirements", "Visa Requirements"],
          ["scholarship", "Scholarship Information"],
          ["work_visa", "Work Visa Information"]
        ].map(([key, label]) => (
          <div className="col-12 my-2" key={key}>
            <label className="lbl-name">{label}</label>
            <Tinymce 
              height={350}
              initialValue={form?.[key]?.content}
              content={form?.[key]?.content}
              handleEditorChange={v => handleChange(key, "content", v)}
            />
          </div>
        ))}

        <button className="btn btn-primary mt-4" onClick={handleSubmit}>Save</button>
      </div>
    </Layout>
  );
}

export default AddAbroad;
